<dsp-content-card [types]="[ 'select', 'select', 'datepicker' ]" [loading]="loading$ | async">
  <div *dsp-content-filter>
    <atlas-field-select *ngIf="!(isMobile$ | async)" [style.--radius-xsmall]="'4px'" [widthValue]="270"
      [size]="sizeMedium" id="funds-select-input" [label]="'Funds'" placeholder="Select" [multiselectable]="true"
      [options]="fundsOptions" [showSelectAll]="true" [checkbox]="true" (valueChange)="onChangeFunds($event)"
      [(ngModel)]="funds" [clearable]="false" [disabled]="!(funds$ | async)?.length">
    </atlas-field-select>

    <atlas-field-select *ngIf="isMobile$ | async" [style.--radius-xsmall]="'4px'" [widthValue]="270" [fullWidth]="true"
      [size]="sizeSmall" id="funds-select-input" [label]="'Funds'" placeholder="Select" [multiselectable]="false"
      [options]="fundsOptions" [showSelectAll]="false" [checkbox]="false" (valueChange)="onChangeFunds($event)"
      [(ngModel)]="selectedFundId" [clearable]="false" [disabled]="!(funds$ | async)?.length">
    </atlas-field-select>
  </div>
  <atlas-field [widthValue]="270" [fullWidth]="(isMobile$ | async)"
    [size]="(isMobile$ | async) ? sizeSmall : sizeMedium" *dsp-content-filter [id]="'date-from-input'">
    <atlas-field-label>From</atlas-field-label>
    <input [(ngModel)]="from" atlasInput [min]="minDate$ | async" [max]="to" [Datepicker]="pickerFrom"
      [placeholder]="'Day Month Year'" (dateChange)="onChangeFrom($event)" [readonly]="true"
      [disabled]="!(minDate$ | async)" />
    <atlas-field-suffix>
      <datepicker-toggle [datepicker]="pickerFrom"></datepicker-toggle>
    </atlas-field-suffix>
    <datepicker #pickerFrom> </datepicker>
  </atlas-field>

  <atlas-field [widthValue]="270" [fullWidth]="(isMobile$ | async)"
    [size]="(isMobile$ | async) ? sizeSmall : sizeMedium" *dsp-content-filter [id]="'date-to-input'">
    <atlas-field-label>To</atlas-field-label>
    <input [(ngModel)]="to" atlasInput [min]="from" [max]="maxDate$ | async" [Datepicker]="pickerTo"
      [placeholder]="'Day Month Year'" (dateChange)="onChangeTo($event)" [readonly]="true"
      [disabled]="!(maxDate$ | async)" />
    <atlas-field-suffix>
      <datepicker-toggle [datepicker]="pickerTo"></datepicker-toggle>
    </atlas-field-suffix>
    <datepicker #pickerTo> </datepicker>
  </atlas-field>

  <div dsp-content>
    <div class="row" *ngIf="!(isMobile$ | async)">
      <ng-container *ngIf="(displayData$ | async)">
        <div class="columns">
          <div class="dsp-title-container">

            <atlas-icon class="transactions-icon" [icon]="'icon-webpage-24'" [size]="'large'" [color]="'primary'"
              [alt]="'Transactions'">
            </atlas-icon>
            <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none mos-u-spacer--padding-left-sm">
              Transactions
            </h3>
            <atlas-icon *ngIf="(notes$ | async)?.transactions !== undefined"
              class="mos-u-spacer--margin-left-xxsm dsp-transaction-summary-tooltip-trigger"
              [haloTooltipWithArrow]="true" [haloTooltip]="(notes$ | async)?.transactions"
              [haloTooltipPosition]="'right'" [haloTooltipShowDelay]="100" [id]="'transactions-note-icon'"
              [icon]="'c-info'" [collection]="'user-interface'" [size]="'small'" [alt]="'info'">
            </atlas-icon>
          </div>
        </div>
        <div class="columns shrink" [style.margin-left]="'auto'" *ngIf="(displayData$ | async)?.length > 0">
          <atlas-dropdown #transactionsSummaryDropdown="atlasDropdown" [id]="'toggle-transactions-export'"
            [icon]="'more_vert'" [iconSize]="sizeMedium" [placement]="dropdownPlacementLeftStart"
            [iconButtonAlt]="'More options'" [iconAriaTitle]="'More options'"
            [triggerType]="dropdownTriggerTypeIconButton">
            <atlas-menu [style.display]="'block'" [style.max-width]="'fit-content'">
              <atlas-menu-item (click)="transactionsSummaryDropdown.menu?.closeMenu($event); onExportPDF()">
                <a [id]="'download-button'">
                  Export as PDF
                </a>
              </atlas-menu-item>
              <atlas-menu-item (click)="transactionsSummaryDropdown.menu?.closeMenu($event); onExportCSV()">
                <a [id]="'export-button'">
                  Export as CSV
                </a>
              </atlas-menu-item>
            </atlas-menu>
          </atlas-dropdown>
        </div>
      </ng-container>
      <ng-container *ngIf="!(displayData$ | async)">
        <p [style.height.px]="300" [style.margin-left.px]="500" [style.margin-top.px]="200"
          [id]="'transactions-no-data'">No Data Available</p>
      </ng-container>
    </div>
    <div *ngIf="!(isMobile$ | async) && (displayData$ | async)" class="row mos-u-spacer--margin-top-md">
      <div class="columns">
        <dsp-transactions-accordion [data]="displayData$ | async" [lastSelection]="lastSelection$ | async" [from]="from"
          [to]="to" [accountId]="accountId" [country]="country">
        </dsp-transactions-accordion>
      </div>
    </div>
    <div *ngIf="(isMobile$ | async)">
      <ng-container *ngIf="(showMobileCards$ | async)">
        <ng-container *ngFor="let data of mobileData$ | async">
          <ng-container *ngFor="let transaction of data.transactions; let first = first">
            <dsp-mobile-transaction-opening-card *ngIf="first" [transaction]="transaction">
            </dsp-mobile-transaction-opening-card>
            <dsp-mobile-transaction-card *ngIf="!first && transaction.description !== 'Closing Balance'"
              [transaction]="transaction">
            </dsp-mobile-transaction-card>
            <dsp-mobile-transaction-opening-card *ngIf="transaction.description === 'Closing Balance'"
              [transaction]="transaction">
            </dsp-mobile-transaction-opening-card>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!(showMobileCards$ | async)">
        <p [style.height.px]="300" [style.margin-left.px]="500" [style.margin-top.px]="200"
          [id]="'transactions-no-data'">No Data Available</p>
      </ng-container>
      <div class="mos-u-spacer--margin-bottom-md" *ngIf="showLoadMore$ | async">
        <atlas-button [style]="'strong'" [expand]="true" (click)="onLoadMore()">Load More</atlas-button>

      </div>
    </div>
    <div *ngIf="(displayData$ | async)?.length || (showMobileCards$ | async)">
      <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
        <span class="dsp-terms-and-conditions-applied">* This is the latest available unit price of the date(s)
          selected.</span>
      </div>
    </div>
  </div>
</dsp-content-card>